import { inject, Pipe, PipeTransform } from '@angular/core';
import { DiaryLogType, LanguageService } from '../../core';


/**
 * Pipe to convert Log Type enum to display value.
 */
@Pipe({
	name: 'logTypeLabel'
})
export class LogTypeLabelPipe implements PipeTransform {

	private readonly langSrv = inject(LanguageService);


	transform(type: DiaryLogType): string | undefined {
		switch (type) {
			case DiaryLogType.AppStateChanged: return this.langSrv.labels().LOG_TYPE_APP_STATE_CHANGED;
			case DiaryLogType.DailyMoodSurveyAnswered: return this.langSrv.labels().LOG_TYPE_DAILY_MOOD_SURVEY_ANSWERED;
			case DiaryLogType.MotivationalMessageFlag: return this.langSrv.labels().LOG_TYPE_MOTIVATIONAL_MESSAGE_FLAG;
			case DiaryLogType.MotivationalMessageRead: return this.langSrv.labels().LOG_TYPE_MOTIVATIONAL_MESSAGE_READ;
			case DiaryLogType.PersonalGoalSet: return this.langSrv.labels().LOG_TYPE_PERSONAL_GOAL_SET;
			case DiaryLogType.PinSiteCareDone: return this.langSrv.labels().LOG_TYPE_PIN_SITE_CARE_DONE;
			case DiaryLogType.PrescriptionUpdated: return this.langSrv.labels().LOG_TYPE_PRESCRIPTION_UPDATED;
			case DiaryLogType.StrutAdjustmentDone: return this.langSrv.labels().LOG_TYPE_STRUT_ADJUSTMENT_DONE;
			case DiaryLogType.StrutAdjustmentPostponed: return this.langSrv.labels().LOG_TYPE_STRUT_ADJUSTMENT_POSTPONED;
			case DiaryLogType.TreatmentRevoked: return this.langSrv.labels().LOG_TYPE_TREATMENT_REVOKED;
			default: return '';
		}
	}

}